import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/deals/[slug]/DealsPageLayout.js");
